<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-lg">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="row">

                            <p class="nonprofit-modal-msg">





                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="registration-title">
                                        <div>
Changing Life through Lenses® Relief Fund (Limited Time Only!)
                                        </div>
                                        </div>
                                    </div>
                                    <div class=" padding-left col-lg-11 col-md-12 col-sm-12 col-xs-12">

        <p class="no-margin-bot">EVF launched the Changing Life through Lenses&reg; (CLTL) Relief Fund to help support and expand the charitable efforts of doctors and nonprofits in response to the increasing need. CLTL participants who provide vision services to Eligible Patients between June 1 through December 31, 2021, can receive funds of up to $1,500.
<b><router-link :to="{ name: 'CovidReliefRegistration'}" target="_blank">Learn More </router-link></b><br></p>
<p><b>                                    Select I AGREE and Submit below to complete your registration for Relief!</b>
<br>
 <ul class="g-font-size-18--md g-font-size-16"><small>
<li>Relief is intended to help support costs for vision services including identifying, qualifying and examining Eligible Patients that result in glasses ordered on changinglifethroughlenses.org; orders of second pairs for one Eligible Patient will not count for two patients</li>
<li>Participant will not bill Medicare, Medicaid and other Federal health care programs or third party insurers for services supported by this Relief.</li>
<li>Relief amount is based on vision services supporting (Tier 1 - $150): 2 or more, (Tier 2 - $900): 12 or more or (Tier 3 - $1,500): 20 or more Eligible Patients with payment contingent upon completion of survey and W9.</li>
<li><b><a href="https://drive.google.com/file/d/1tR14hA3fqKN0fGNrCHlqf-SW_Kuk7gJg/view?usp=sharing" target="_blank">Click here</a></b> for Terms and Conditions</li></small>
</ul>
        </p>

      </div>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom">

                                        <label class="radio form-check-label input-space-right"
                                        ><input
                                            v-model="CovidReliefParticipantStatus"
                                            type="radio"
                                            name="yesiwant"
                                            value=yes
                                        />
                                        I AGREE and am interested in participating in CLTL Relief.</label
                                        >
                                        <br />
                                        <label class="radio form-check-label input-space-right"
                                        ><input
                                            type="radio"
                                            v-model="CovidReliefParticipantStatus"
                                            name="nothanks"
                                            value=no
                                        />
                                        I DISAGREE and am not interested in participating in CLTL Relief.<br />
                                        <small v-if="(CovidReliefParticipantStatus == 'no')"> No problem, if you change your mind, you can enroll later on the Resources page.</small>
                                        </label>
                                        
                                        <br />
                                        
                                        <label class="radio form-check-label input-space-right">
                                        <input
                                            type="radio"
                                            v-model="CovidReliefParticipantStatus"
                                            name="remindLater"
                                            value=remindLater
                                        />
                                        I am not ready to decide right now, remind me later.                                        <small v-if="(CovidReliefParticipantStatus == 'remindLater')"></br> No problem, we'll show you this screen again next time you login.</small>
</label>
                                        <br />
                                    </div>
                                    </div>

                            </p>
                  </div>
                </div>
                <loading-component v-if="isFormLoading"></loading-component>

                <div class="row">
                    <div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center">
                        <button @click="SubmitCRPS()" v-bind:disabled="!(CovidReliefParticipantStatus.trim() != '' ? true : false)" type="button" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Submit</button>
                    </div>
                </div>



            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

import CovidRelief from "@/components/AccountDetails/CovidRelief";
import LoadingComponent from "@/components/shared/LoadingComponent";

export default {
  props: [],
  components: {
      CovidRelief,
      LoadingComponent
      },
  data() {
    return {
      isFormLoading: false,
      isModalShown: true,
      CovidReliefParticipantStatus: '',
    }
  },
  methods: {
    CloseModal() {
      this.$emit('CtlModalForm');
    },
    SubmitCRPS() {
      var _this = this;
      _this.isFormLoading = true;
      axios
        .post("/Account/CovidReliefParticipant", {
            response: this.CovidReliefParticipantStatus
        },{
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(function (response) {
            if(response.data.isSuccess == true){
                localStorage.setItem("covidReliefParticipantStatus", response.data.raw.covidReliefParticipantStatus)
                localStorage.setItem("isCovidReliefStatusChecked", "true")
               
               _this.isFormLoading = false;
                _this.CloseModal(); 
                // alert("Your feedback was saved.")
            } else {
              localStorage.setItem("isCovidReliefStatusChecked", "true")
                alert("We got an Error on your request.")
                _this.isFormLoading = false;
                _this.CloseModal();
            }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  created() {
    // get covid relief status
    // if enrolled, declined, show modal  = false
    // if remind, , show modal  = true
    //  
  },
};
</script>


// WEBPACK FOOTER //
// CovidRelief.vue?7dd6156d